/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type CompanySize = (typeof CompanySize)[keyof typeof CompanySize];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompanySize = {
  SMALL_COMPANY: "SMALL_COMPANY",
  MEDIUM_COMPANY: "MEDIUM_COMPANY",
  LARGE_COMPANY: "LARGE_COMPANY",
} as const;
